import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/about')({
  component: About,
})

function About() {
  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-12 sm:px-6">
      <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_1px_2px_rgba(15,23,42,0.06)] sm:p-8 dark:border-slate-800 dark:bg-slate-900">
        <p className="mb-3 font-mono text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-blue-700 dark:text-blue-400">
          About
        </p>
        <h1 className="mb-4 text-4xl font-bold tracking-tight text-slate-900 font-stretch-[112%] sm:text-5xl dark:text-white">
          Lockers first, software always.
        </h1>
        <p className="m-0 max-w-3xl text-base leading-8 text-slate-600 dark:text-slate-400">
          Lugstash builds modular parcel locker walls and the fleet console that
          runs them. Every wall we ship reports back to the same platform —
          live cell status, over-the-air firmware, payments, and a full audit
          trail — so one operator can run a hundred locations as easily as
          one.
        </p>
      </section>
    </main>
  )
}
